<template>
  <div class="contact">
    <header-info activeName="/contact"></header-info>
    <div class="detail">
      <section class="img">
        <el-button class="login" @click="goLogin">立即登录</el-button>
        <div class="infocard">
          <el-card class="box-card">
            <div class="what">是什么？</div>
            <div class="para">
              <span class="empsis">宏观和行业全口径数据库</span>是我们研究团队对投入产出体系动态化、实时化改造而构建的具有创新性、复杂性和实用性的新型数据体系。投入产出表最初由美国经济学家、诺奖获得者列昂惕夫提出，是迄今为止反映宏观经济和行业关联关系最为完整的方法体系。我们在研发并验证一系列转换矩阵表的基础上，在投入产出体系的需求侧和生产侧之间建立起高度复杂的高频关联关系，形成了“多维动态均衡矩阵系统（MDEMS）”。这是一项难度很大、国内外此前尚无人做过的基础性研究工作。
            </div>
          </el-card>
        </div>
      </section>
      <section class="character">
        <div class="titlerow">特点</div>
        <div class="up">
          <div class="upimg">
            <img src="@/assets/img/introduce/full02.png" alt />
          </div>
          <div class="team">
            <div class="title">全口径数据</div>
            <div
              class="teamdown"
            >官方每月发布的数据，大部分属于片段性数据，比如社会消费品零售总额，反映的只是部分商品消费，还不包括服务消费；固定资产投资完成额也没有剔除土地使用费等，与构成GDP的固定资本形成差距较大。另外，目前的月度官方统计中，还不能提供大部分服务业的增长数据。而我们的全口径数据体系中，提供了需求侧（支出法）和供给侧（生产法）各个部分的全口径月度数据，包括全部服务业增长的月度数据。</div>
          </div>
        </div>
        <div class="up mid">
          <div class="team">
            <div class="title">全方位装备</div>
            <div
              class="teamdown"
            >各类经济数据，不论来自何方，宏观的、行业的、区域的、企业的，都能在这一体系中找到一个合适位置，相互关联、相互推导、相互印证，使各类数据能够真正发挥它们的作用。</div>
          </div>
          <div class="upimg">
            <img src="@/assets/img/introduce/full03.png" alt />
          </div>
        </div>
        <div class="up">
          <div class="upimg">
            <img src="@/assets/img/introduce/full04.png" alt />
          </div>
          <div class="team">
            <div class="title">全面反映联系</div>
            <div
              class="teamdown"
            >全面反映并显示各类数据之间的联系和关系。数据库中“结构”板块展示了需求侧和供给侧不同层面的比例关系，其中的“增量”结构直观了反映经济增长新动能；“拉动”板块体现了经济体系中不同部分之间复杂的相互带动关系，比如疫情期间服务业下滑对全社会增加值的影响，出口增加对计算机、通信和其他电子设备制造业增长的影响等，都可具体得以展现。“关联”栏目则全面显示了具体行业上下游的投入产出图谱，如黑色金属冶炼及压延加工业的上游和下游各有哪些行业，相关部分由现价和不变价计算的规模和比重各是多少，都能一目了然。</div>
          </div>
        </div>
      </section>
      <section class="use-info">
        <div class="usebox">
          <p class="usetitle">对谁有用</p>
          <p class="titlerow">对深耕中国宏观经济和行业发展研究的专业研究机构和人士都有用。重点是</p>
          <p class="titlerow">政府综合性经济事务主管机构和较高水准的研究型智库，</p>
          <p class="titlerow">大型企业的战略研究部门，中小企业对深度经济研究感兴趣者，</p>
          <p class="titlerow">银行、证券、保险、资管等各类金融机构，</p>
          <p class="titlerow">深度研究中国经济的专业科研人员，等等。</p>
          <p class="titlerow lastrow">观和行业全口径数据库是每一个志在高质量研究中国经济的机构和人士的</p>
          <p class="titlerow lastrow">“专属产品”</p>
        </div>
      </section>
      <section class="data">
        <div class="titlerow">我们提供的数据</div>
        <div class="up">
          <div class="index-content">
            <el-tabs v-model="activeIndex" @tab-click="handleClick">
              <el-tab-pane
                :label="tab.indexName"
                :name="tab.id"
                v-for="tab in rightTabs"
                :key="tab.id"
              ></el-tab-pane>
            </el-tabs>
            <el-tabs
              style="margin-top:18px"
              v-model="secondActiveIndex"
              @tab-click="handleSecondClick"
            >
              <el-tab-pane
                :label="tab.indexName"
                :name="tab.id"
                v-for="tab in secondTab"
                :key="tab.id"
              ></el-tab-pane>
            </el-tabs>
            <div class="chart-wrap" v-if="indexLines.length">
              <div
                class="chart-item"
                :style="{width:(100/lineSize)+'%'}"
                v-for="line in indexLines"
                :key="line.id"
              >
                <div class="chart">
                  <div class="title">{{line.indexName}}</div>
                  <div class="line-chart" @click="goLogin">
                    <line-chart :noShadow="noShadow" :indexId="line.id" :indexName="line.indexName"></line-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <footer-info></footer-info>
  </div>
</template>

<script>
import headerInfo from "@/pages/layout/introHeader.vue";
import footerInfo from "@/pages/layout/footer.vue";
import { findIndexStructure } from "@/api/product";
import mixin from "@/utils/mixins.js";
import lineChart from "@/pages/product//lineChart.vue";
export default {
  mixins: [mixin],
  components: {
    headerInfo,
    footerInfo,
    lineChart
  },
  data() {
    return {
      active: "7",
      activeIndex: "", // 右侧tab
      rightTabs: [],
      indexLines: [],
      secondActiveIndex: "",
      secondTab: [],
      lineSize: 4,
      noShadow: false
    };
  },
  created() {
    this.handleFindIndexStructure();
  },
  methods: {
    async handleFindIndexStructure() {
      let { data } = await findIndexStructure({
        systemId: this.active
      });
      this.rightTabs = data.resultBody;
      if (this.rightTabs) {
        this.activeIndex = this.rightTabs[0].id;
        this.indexLines = this.rightTabs[0].indexList;
        this.lineSize = this.rightTabs[0].lineSize;
      }
    },
    handleClick(val) {
      this.indexLines = [];
      this.secondTab = [];
      let arr = this.rightTabs.filter(i => i.id == val.name);
      // 存在二级
      if (arr[0].nextList) {
        this.secondTab = arr[0].nextList;
        // 默认激活
        this.secondActiveIndex = this.secondTab[0].id;
        this.indexLines = arr[0].nextList[0].indexList;
      } else {
        this.secondTab = [];
        this.indexLines = arr[0].indexList;
      }
      this.lineSize = arr[0].lineSize;
    },
    handleSecondClick(val) {
      this.indexLines = [];
      let arr = this.secondTab.filter(i => i.id == val.name);
      this.indexLines = arr[0].indexList;
    },
    goLogin() {
      this.goMacro1("full");
    }
  }
};
</script>

<style lang="scss" scoped>
.contact {
  display: flex;
  flex-direction: column;
  // height: 100vh;
  overflow: hidden;
  .detail {
    flex: 1;
    background: #fff;
    .img {
      height: 1000px;
      background: url("../../assets/img/introduce/full01.png") no-repeat;
      background-color: #f3f3f3;
      text-align: center;
      .login {
        background-color: #fff;
        border-color: #fff;
        border-radius: 30px;
        color: #4f0188;
        width: 200px;
        height: 60px;
        margin-top: 500px;
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 158px;
      }
      .infocard {
        margin: 0px 500px;
        margin-top: -100px;
        .box-card {
          padding: 30px;
          .what {
            height: 50px;
            text-align: left;
            font-size: 30px;
            color: #1c2d86;
          }
          .para {
            padding: 0 8px;
            margin-top: 30px;
            line-height: 30px;
            text-align: left;
            .empsis {
              font-weight: 700;
              font-size: 20px;
              margin-right: 4px;
            }
          }
        }
      }
    }
    .titlerow {
      color: #1c2d86;
      font-size: 30px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 100px;
    }
    .character {
      background-color: #f3f3f3;
      padding: 80px 400px 50px;
      .up {
        display: flex;
        margin: 100px 0;
        height: 380px;
        .upimg {
          flex: 1;
          height: 100%;
          width: 100%;
          margin-right: 50px;
        }
        .team {
          flex: 1;
          .title {
            font-size: 24px;
            font-weight: 700;
            margin-bottom: 30px;
            margin-top: 20px;
          }
          .teamdown {
            line-height: 30px;
            color: #5f5f5f;
            font-size: 18px;
          }
        }
      }
      .mid {
        .upimg {
          margin-right: 0;
          margin-left: 50px;
        }
      }
    }
    .use-info {
      height: 550px;
      padding-top: 10px;
      background: url("../../assets/img/introduce/full05.png") no-repeat;
      .usebox {
        .usetitle {
          font-size: 36px;
          font-weight: 700;
          color: #25bfff;
          text-align: center;
        }
        .titlerow {
          text-align: center;
          color: #fff;
          font-size: 26px;
          font-weight: 700;
          margin: 30px 0;
        }
        .lastrow {
          margin: 10px 0;
        }
      }
    }
    .data {
      padding: 80px 400px 60px;
      .titlerow {
        margin-bottom: 50px;
      }
      .up {
        .index-content {
          margin: 20px 0 0 20px;
          padding: 20px;
          background: #fff;
          border-radius: 10px;
          .chart-wrap {
            display: flex;
            flex-wrap: wrap;
            .chart-item {
              padding: 10px;
              box-sizing: border-box;
              .chart {
                border: 1px solid #c9c9c9;
                height: 190px;
                padding: 10px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                .line-chart {
                  flex: 1;
                }
              }
            }
          }
          /deep/ .el-tabs__item {
            padding-left: 0 !important;
            padding-right: 50px;
            height: 42px !important;
            font-size: 18px;
          }
          /deep/ .el-tabs__item:hover {
            color: #2c58ff;
          }
          /deep/ .el-tabs__item.is-active {
            color: #2c58ff;
            font-weight: 500;
          }
          /deep/ .el-tabs__active-bar {
            background-color: #2c58ff;
            height: 3px;
          }
          /deep/ .el-tabs__nav-wrap::after {
            height: 0;
          }
        }
      }
    }
  }
}
</style>